import { useEffect, type ReactNode } from "react";
import {
  ADMIN_APP_URL,
  usePlatformCutoverFlag,
} from "@/hooks/usePlatformCutoverFlag";

/**
 * Ver docs em apps/crm/src/components/AdminCutoverGate.tsx.
 */
export function AdminCutoverGate({ children }: { children: ReactNode }) {
  const { data: enabled } = usePlatformCutoverFlag();

  useEffect(() => {
    if (!enabled) return;
    // boundary (?=\/|$) — não casa /administracao etc
    const path = window.location.pathname.replace(/^\/admin(?=\/|$)/, "") || "/";
    const target = `${ADMIN_APP_URL}${path}${window.location.search}`;
    window.location.replace(target);
  }, [enabled]);

  return <>{children}</>;
}
